import { cn } from "@/lib/util";

const META = {
  active:        { label: "Licencia activa",  cls: "border-emerald-500/60 text-emerald-400 bg-emerald-500/10", dot: "bg-emerald-400" },
  expiring_soon: { label: "Vence pronto",     cls: "border-amber-400/60 text-amber-300 bg-amber-400/10",     dot: "bg-amber-300" },
  expired:       { label: "Licencia vencida", cls: "border-sev-critical/60 text-sev-critical bg-sev-critical/10", dot: "bg-sev-critical" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("es-CL") : "—");

export function LicenseBadge({ client, testid }) {
  const m = META[client?.license_status];
  if (!m) return null;
  const left = client.license_days_left;
  return (
    <div className={cn("inline-flex items-center gap-2 border px-2 py-1 font-mono text-[10px] tracking-widest uppercase", m.cls)}
         data-testid={testid || `license-badge-${client.id}`}>
      <span className={cn("w-1.5 h-1.5 rounded-full", m.dot)} />
      {m.label}
      <span className="normal-case tracking-normal opacity-90">
        · {client.license_status === "expired" ? "venció" : "vence"} {fmtDate(client.license_end_date)}
        {client.license_status === "expiring_soon" && left != null ? ` (${left} d)` : ""}
      </span>
    </div>
  );
}
